import React, {Component} from 'react'

class Help007 extends Component {
  constructor (props) {
    super(props)
    document.querySelector("meta[name='viewport']").setAttribute('content', 'width=1158px,shrink-to-fit=yes')
  }
  render () {
    return (
      <div className='container-fluid'>
        <div className='row-fluid'>
          <div className='span1' />
          <div className='span14 help-area'>
            <div className='page-header'>
              <h2><i className='icon-question-sign icon-large' />パスワードを変更する</h2>
            </div>{/* ./page-header */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[7-1]</span>画面上部のメニューの中の「個人設定」の「パスワード変更」(図7-1 参照)を押してください。</legend>
              <figcaption>図7-1</figcaption>
              <ul>
                <li><img alt='' src='/help/help_7-1.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[7-2]</span>画面の中の「現在のパスワード」、「新しいパスワード」、「新しいパスワード(確認用)」を入力して、「パスワードを変更する」ボタン(図7-2 参照)を押してください。</legend>
              <figcaption>図7-2</figcaption>
              <ul>
                <li><img alt='' src='/help/help_7-2.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
            <div className='blockoff-left'>
              <legend className='lead'><span className='label label-warning'>[7-3]</span>メッセージが表示されるので「OK」ボタンを押してください。(図7-3 参照)</legend>
              <figcaption>図7-3</figcaption>
              <ul>
                <li><img alt='' src='/help/help_7-3.png' /></li>
              </ul>
            </div>{/* ./blockoff-left */}
          </div>{/* ./help-area */}
        </div>
      </div>
    )
  }
}

export default Help007



// WEBPACK FOOTER //
// ./src/help/Help007.js